import React from 'react';
import { cn } from '@rocco/utils/cn';
import { ReactComponent as CheckIcon } from '@rocco/icons/svg/check.svg';
import { useFiltersContext } from '@rocco/ui/filter-sort/components/Filters';
import type { FilterConfigModalItemColor } from '@rocco/ui/filter-sort/types/filter-config-modal';
import type { MultipleValuesFilterState } from '@rocco/ui/filter-sort/view-models/filter-state/multiple-values-filter-state';
import type { FilterModalElementProps } from '@rocco/ui/filter-sort/components/filters-modal/FiltersModalElement';

export const FiltersModalColors = (
    props: FilterModalElementProps<
        FilterConfigModalItemColor,
        MultipleValuesFilterState
    >,
) => {
    const { filterState, onFilterStateUpdate } = props;
    const {
        searchFilters: { handleToggleMultipleValues },
    } = useFiltersContext();

    return (
        <div className="flex flex-wrap gap-2 pt-2">
            {filterState.items.map((item) => {
                // item color value (item.label) can be merged color like "#fff,#aaa,#000"
                // show them as a linear gradient
                // additionally it can have some raw CSS value like "linear-gradient(180deg, #D8D8D8 0%, #B4B4B4 100%)"
                const colors = item.label?.startsWith('#')
                    ? item.label.split(',')
                    : item.label
                      ? [item.label]
                      : ['#fff'];
                const background =
                    colors.length > 1
                        ? `linear-gradient(to right, ${colors.join(', ')})`
                        : colors[0];

                return (
                    <div
                        key={item.value}
                        className={cn(
                            'relative h-6 w-15 cursor-pointer rounded-1 border',
                            // A faint border keeps white/light swatches
                            // visible on light surfaces.
                            item.checked
                                ? 'border-gray-900'
                                : 'border-black/10',
                        )}
                        style={{ background, backgroundOrigin: 'border-box' }}
                        data-color={item.value}
                        onClick={() => {
                            if (handleToggleMultipleValues) {
                                onFilterStateUpdate(
                                    handleToggleMultipleValues(
                                        filterState,
                                        item,
                                        !item.checked,
                                    ),
                                );
                            }
                        }}
                    >
                        {item.checked && (
                            <span className="absolute inset-0 flex items-center justify-center">
                                <span className="flex size-4 items-center justify-center rounded-full bg-black/60">
                                    <CheckIcon className="size-2.5 fill-white" />
                                </span>
                            </span>
                        )}
                    </div>
                );
            })}
        </div>
    );
};
